module.exports = __webpack_public_path__ + "static/Pento-a0056ed0f39745103cad192647eed437.jpg";